export enum TaskType {
  NORMAL = "normal", // 普通任务
  AGENT = "agent", // 智能代理任务
}
